import React, { Component, useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";

import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import SidebarModal from "./SidebarModal";

const localizer = momentLocalizer(moment);
const DnDCalendar = withDragAndDrop(Calendar);

const getRandomColor = () => {
  const colors = [
    "#f87171", // red-400
    "#60a5fa", // blue-400
    "#34d399", // green-400
    "#fbbf24", // yellow-400
    "#a78bfa", // purple-400
    "#fb923c", // orange-400
    "#38bdf8", // sky-400
    "#f472b6", // pink-400
  ];
  return colors[Math.floor(Math.random() * colors.length)];
};

const testData = [
  {
    title: "Product Design Sprint",
    start: moment().startOf("day").toDate(),
    end: moment().add(1, "days").endOf("day").toDate(),
    color: getRandomColor(),
  },
  {
    title: "Marketing Strategy Meeting",
    start: moment().add(2, "days").toDate(),
    end: moment().add(2, "days").toDate(),
    color: getRandomColor(),
  },
  {
    title: "Frontend Development Sprint",
    start: moment().subtract(3, "days").toDate(),
    end: moment().add(1, "days").toDate(),
    color: getRandomColor(),
  },
  {
    title: "Sales Team Check-in",
    start: moment().add(5, "days").toDate(),
    end: moment().add(5, "days").toDate(),
    color: getRandomColor(),
  },
  {
    title: "Backend System Review",
    start: moment().add(7, "days").toDate(),
    end: moment().add(9, "days").toDate(),
    color: getRandomColor(),
  },
  {
    title: "Release Planning",
    start: moment().add(10, "days").toDate(),
    end: moment().add(10, "days").toDate(),
    color: getRandomColor(),
  },
  {
    title: "Internal Demo",
    start: moment().subtract(5, "days").toDate(),
    end: moment().subtract(5, "days").toDate(),
    color: getRandomColor(),
  },
  {
    title: "QA Testing Phase 1",
    start: moment().add(14, "days").toDate(),
    end: moment().add(17, "days").toDate(),
    color: getRandomColor(),
  },
  {
    title: "Support Team Workshop",
    start: moment().add(3, "weeks").toDate(),
    end: moment().add(3, "weeks").add(1, "days").toDate(),
    color: getRandomColor(),
  },
  {
    title: "Annual Company Review",
    start: moment().add(1, "months").toDate(),
    end: moment().add(1, "months").add(2, "days").toDate(),
    color: getRandomColor(),
  },
];

const MyStyle = ({ selected }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedCoordinates, setSelectedCoordinates] = useState(null);

  const ParsedData = JSON.parse(selected.calendar_drill);

  // Get the keys (like transaction_details, other_details)
  const sectionKeys = Object.keys(ParsedData);

  // Get section titles from keys (e.g., "transaction_details" → "Transaction Details")
  const getTitleFromKey = (key) =>
    key.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

  console.log("the parsed data is", ParsedData);

  return (
    <div className="pt-4">
      {/* First Section */}
      <h2 className="uppercase font-semibold text-md pb-5">
        {getTitleFromKey(sectionKeys[0])}
      </h2>
      <hr className="pb-5" />

      {ParsedData &&
        Object.entries(ParsedData[sectionKeys[0]] || {}).map(([key, value]) => (
          <div className="flex justify-between pb-4" key={key}>
            <h2 className="capitalize bg-red-100 text-red-600 rounded-sm px-1 py-[2px] text-sm font-semibold">
              {key}
            </h2>
            <h2 className="capitalize font-semibold text-sm">{value}</h2>
          </div>
        ))}

      {/* Second Section */}
      <div className="px-4 py-2 mt-5 bg-gray-100 rounded-sm ">
        <h2 className="pt-4 pb-2">{getTitleFromKey(sectionKeys[1])}</h2>
        <hr className="pb-6" />

        {ParsedData &&
          Object.entries(ParsedData[sectionKeys[1]] || {}).map(
            ([key, value]) => (
              <div className="flex justify-between pb-2" key={key}>
                <h2 className="capitalize text-gray-400/80 rounded-sm px-1 py-[2px] text-sm font-semibold">
                  {key}
                </h2>
                <h2 className="capitalize font-semibold text-sm">{value}</h2>
              </div>
            )
          )}
      </div>
    </div>
  );
};
function CalenderControl1({
  setLoading,
  name,
  options,
  selectedCalenderControl,
}) {
  options = selectedCalenderControl?.options ?? options;

  console.log("the options are", options, selectedCalenderControl);

  const calenderData = (options ?? [])[0] ?? {};

  const [events, setEvents] = useState([]);
  const [selected, setSelected] = useState({});
  const [inProp, setInProp] = useState(false);

  const transformEvents = (backendEvents) => {
    return backendEvents
      ? backendEvents.map((event) => ({
          ...event,
          start: new Date(event.start),
          end: new Date(event.end),
        }))
      : {};
  };

  useEffect(() => {
    const transformed = transformEvents(calenderData?.data);
    setEvents(transformed);
  }, [calenderData]);

  const onEventResize = (data) => {
    const { start, end } = data;

    setEvents((state) => {
      state.events[0].start = start;
      state.events[0].end = end;
      return { events: [...state.events] };
    });
  };

  const onEventDrop = (data) => {
    console.log(data);
  };

  const onSelect = (item) => {
    console.log("does this onselect work", item);
    setSelected(item);
    setInProp(true);
  };

  console.log("the current events", testData, events);
  return (
    <>
      <div className="text-custom-black-100 border p-2 shadow-md">
        <Calendar
          defaultDate={moment().toDate()}
          defaultView="month"
          events={events}
          localizer={localizer}
          onEventDrop={onEventDrop}
          onEventResize={onEventResize}
          onSelectEvent={(event) => onSelect(event)} // 👈 Select handler
          resizable
          style={{ height: "100vh" }}
          eventPropGetter={(event) => ({
            style: {
              backgroundColor: event.color,
              color: "#fff",
              borderRadius: "4px",
              padding: "2px 4px",
              border: "none",
            },
          })}
        />
      </div>
      {selected && (
        <SidebarModal inProp={inProp} closeSidebar={() => setInProp(false)}>
          <MyStyle selected={selected} />
        </SidebarModal>
      )}
    </>
  );
}

export default CalenderControl1;
